export default __webpack_public_path__ + "static/media/Scarclaw Boots.93f04e5c.jpg";